(function ($, XTT) {
	'use strict';

	XTT.sidebarnav = {
		_autoload: [
			'bindSidebarNavEvents',
			'bindToggleActiveClass'
		],

		bindSidebarNavEvents: function () {
			$('.mobile-sidebar-trigger').on('click', XTT.sidebarnav.handleSidebarOpening);
		},

		handleSidebarOpening: function(e) {
			var $this = $(this);
			e.preventDefault();
			$this.next('ul').toggleClass('open');
		},

		bindToggleActiveClass: function () {
			$('.sidebar-nav ul > li a[href]').filter(function() {
			    return $(this)[0].pathname === window.location.pathname;
			}).parent().addClass('active');
		}

	};

})
(jQuery, XTT);